import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import api, { getErr } from "../../lib/api";
import { NeonButton, NeonCard, Spinner, Pill } from "../../components/Neon";
import { fmtDateTime } from "../../lib/format";

export default function AdminDiscounts() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [code, setCode] = useState("");
  const [percent, setPercent] = useState(10);
  const [saving, setSaving] = useState(false);

  const load = () => api.get("/admin/discounts").then(({ data }) => setList(data || [])).catch(() => {}).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!code) { toast.error("Enter a code."); return; }
    setSaving(true);
    try { await api.post("/admin/discounts", { code: code.toUpperCase(), percent: Number(percent), active: true }); toast.success("Discount created."); setCode(""); load(); }
    catch (e) { toast.error(getErr(e)); } finally { setSaving(false); }
  };

  if (loading) return <Spinner />;
  return (
    <div data-testid="admin-discounts">
      <h2 className="font-display uppercase text-2xl text-white">Discount Codes</h2>
      <NeonCard variant="flow" className="mt-4" innerClassName="p-5">
        <div className="flex flex-wrap gap-3 items-end">
          <div><label className="text-xs uppercase tracking-widest text-[var(--text-muted)]">Code</label><input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} className="mt-1 bg-[var(--surface-2)] border border-white/10 rounded-lg px-3 py-2 text-white text-sm" data-testid="discount-code" /></div>
          <div><label className="text-xs uppercase tracking-widest text-[var(--text-muted)]">Percent</label><input type="number" value={percent} onChange={(e) => setPercent(e.target.value)} className="mt-1 w-24 bg-[var(--surface-2)] border border-white/10 rounded-lg px-3 py-2 text-white text-sm" data-testid="discount-percent" /></div>
          <NeonButton variant="pink" onClick={add} loading={saving} data-testid="add-discount-button"><Plus className="h-4 w-4" /> Create</NeonButton>
        </div>
      </NeonCard>
      <NeonCard variant="soft" className="mt-4" innerClassName="p-0">
        <div className="overflow-x-auto"><table className="w-full text-sm">
          <thead><tr className="text-left text-[var(--text-muted)] border-b border-white/10"><th className="p-3">Code</th><th>Percent</th><th>Status</th><th className="p-3">Created</th></tr></thead>
          <tbody>{list.map((d) => (<tr key={d.id} className="border-b border-white/5"><td className="p-3 font-mono text-[var(--neon-cyan)]">{d.code}</td><td className="text-white">{d.percent}%</td><td><Pill color={d.active ? "green" : "grey"}>{d.active ? "Active" : "Inactive"}</Pill></td><td className="p-3 text-[var(--text-muted)]">{fmtDateTime(d.created_at)}</td></tr>))}</tbody>
        </table></div>
      </NeonCard>
    </div>
  );
}
